
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.867 0H.586A.586.586 0 000 .586v8.242c0 .324.262.586.586.586h8.281a.586.586 0 00.586-.586V.586A.586.586 0 008.867 0zM11.21 3.555h2.345c.969 0 1.758.788 1.758 1.757V7.07l-.704-.937a.586.586 0 00-.937.703L15.43 9.18c.234.312.704.31.937 0l1.758-2.344a.586.586 0 10-.938-.703l-.703.937V5.312a2.933 2.933 0 00-2.93-2.93h-2.343a.586.586 0 000 1.173zM15.313 10.586a4.693 4.693 0 00-4.688 4.687c0 2.607 2.103 4.727 4.688 4.727C17.896 20 20 17.88 20 15.273a4.693 4.693 0 00-4.688-4.687zM8.867 16.445H6.523a1.76 1.76 0 01-1.757-1.758V12.93l.703.938a.586.586 0 10.937-.703L4.648 10.82l-.006-.008a.585.585 0 00-.924 0l-.007.008-1.758 2.344a.586.586 0 10.938.703l.703-.938v1.758a2.933 2.933 0 002.93 2.93h2.343a.586.586 0 100-1.172z","fill":"#000"}})])
          )
        }
      }
    